import StatusSummaryMobile from "./StatusSummaryMobile";

export default StatusSummaryMobile;
export { StatusSummaryMobile };
